import React, { useState } from 'react';
import { Message, Assistant } from '@/types';
import { Copy, Check } from 'lucide-react';
import { MessageContent } from './';  // ← Updated!
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';

interface MessageBubbleProps {
    message: Message;
    assistant: Assistant;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, assistant }) => {
    const isUser = message.role === 'user';
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(message.content);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
    };

    return (
        <div className={`flex gap-2 sm:gap-3 animate-fade-in ${isUser ? 'justify-end' : 'justify-start'}`}>
            <div className={`flex gap-2 sm:gap-3 max-w-[95%] sm:max-w-[85%] ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
                {/* Only show icon for assistant messages */}
                {!isUser && (
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0">
                        {renderAssistantIcon({
                            assistant,
                            size: 'md'
                        })}
                    </div>
                )}

                <div className="flex-1 min-w-0">
                    <div className="relative">
                        <div className="px-2 sm:px-4 pt-2 sm:pt-3 pb-1">
                            <MessageContent
                                content={message.content}
                                role={message.role}
                            />
                        </div>
                    </div>

                    <div className="flex items-center gap-2 px-2 sm:px-4">
                        <p className="text-[10px] sm:text-xs text-gray-500">
                            {new Date(message.timestamp).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </p>

                        {/* Copy button - only show for assistant messages */}
                        {!isUser && (
                            <button
                                onClick={handleCopy}
                                className="p-1 text-gray-400 hover:text-gray-300 transition-all duration-200"
                                title={copied ? 'Copied!' : 'Copy message'}
                            >
                                {copied ? (
                                    <Check className="w-3.5 h-3.5" />
                                ) : (
                                    <Copy className="w-3.5 h-3.5" />
                                )}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};